import styled from "styled-components"

const Wrapper = styled.div`
  width: 24px;
  height: 24px;
  position: relative;
`

const Bar = styled.div<{
  isOpened: boolean
  top?: boolean
  middle?: boolean
  bottom?: boolean
}>`
  position: absolute;
  height: 2px;
  width: 22px;
  background-color: #000;
  border-radius: 1px;
  top: 50%;
  left: 50%;
  transition-duration: 0.2s;

  ${props =>
    props.top &&
    (props.isOpened
      ? `
        transform: translateX(-50%) rotate(-45deg);
      `
      : `
        transform: translate(-50%, -7px);
  `)}
  
  ${props =>
    props.middle &&
    (props.isOpened
      ? `
        transform: translateX(-50%);
        opacity: 0;
      
  `
      : `
    transform: translate(-50%, 0);
  `)}
  
  ${props =>
    props.bottom &&
    (props.isOpened
      ? `
        transform: translateX(-50%) rotate(45deg);
      
  `
      : `
    transform: translate(-50%, 7px);
  `)}
`

const Styled = {
  Wrapper,
  Bar,
}

export default Styled
